(function (global) {
/**
 * Heir v3.0.0 - http://git.io/F87mKg
 * Oliver Caldwell - http://oli.me.uk/
 * Unlicense - http://unlicense.org/
 */

(function (name, root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory();
    }
    else {
        root[name] = factory();
    }
}('heir', this, function () {
    /*global define,module*/
    'use strict';

    var heir = {
        /**
         * Causes your desired class to inherit from a source class. This uses
         * prototypical inheritance so you can override methods without ruining
         * the parent class.
         *
         * This will alter the actual destination class though, it does not
         * create a new class.
         *
         * @param {Function} destination The target class for the inheritance.
         * @param {Function} source Class to inherit from.
         * @param {Boolean} addSuper Should we add the _super property to the prototype? Defaults to true.
         */
        inherit: function inherit(destination, source, addSuper) {
            var proto = destination.prototype = heir.createObject(source.prototype);
            proto.constructor = destination;

            if (addSuper || typeof addSuper === 'undefined') {
                destination._super = source.prototype;
            }
        },

        /**
         * Creates a new object with the source object nestled within its
         * prototype chain.
         *
         * @param {Object} source Method to insert into the new object's prototype.
         * @return {Object} An empty object with the source object in it's prototype chain.
         */
        createObject: Object.create || function createObject(source) {
            var Host = function () {};
            Host.prototype = source;
            return new Host();
        },

        /**
         * Mixes the specified object into your class. This can be used to add
         * certain capabilities and helper methods to a class that is already
         * inheriting from some other class. You can mix in as many object as
         * you want, but only inherit from one.
         *
         * These values are mixed into the actual prototype object of your
         * class, they are not added to the prototype chain like inherit.
         *
         * @param {Function} destination Class to mix the object into.
         * @param {Object} source Object to mix into the class.
         */
        mixin: function mixin(destination, source) {
            return heir.merge(destination.prototype, source);
        },

        /**
         * Merges one object into another, change the object in place.
         *
         * @param {Object} destination The destination for the merge.
         * @param {Object} source The source of the properties to merge.
         */
        merge: function merge(destination, source) {
            var key;

            for (key in source) {
                if (heir.hasOwn(source, key)) {
                    destination[key] = source[key];
                }
            }
        },

        /**
         * Shortcut for `Object.prototype.hasOwnProperty`.
         *
         * Uses `Object.prototype.hasOwnPropety` rather than
         * `object.hasOwnProperty` as it could be overwritten.
         *
         * @param {Object} object The object to check
         * @param {String} key The key to check for.
         * @return {Boolean} Does object have key as an own propety?
         */
        hasOwn: function hasOwn(object, key) {
            return Object.prototype.hasOwnProperty.call(object, key);
        }
    };

    return heir;
}));

/*!
 * EventEmitter v4.2.11 - git.io/ee
 * Unlicense - http://unlicense.org/
 * Oliver Caldwell - http://oli.me.uk/
 * @preserve
 */

;(function () {
    'use strict';

    /**
     * Class for managing events.
     * Can be extended to provide event functionality in other classes.
     *
     * @class EventEmitter Manages event registering and emitting.
     */
    function EventEmitter() {}

    // Shortcuts to improve speed and size
    var proto = EventEmitter.prototype;
    var exports = this;
    var originalGlobalValue = exports.EventEmitter;

    /**
     * Finds the index of the listener for the event in its storage array.
     *
     * @param {Function[]} listeners Array of listeners to search through.
     * @param {Function} listener Method to look for.
     * @return {Number} Index of the specified listener, -1 if not found
     * @api private
     */
    function indexOfListener(listeners, listener) {
        var i = listeners.length;
        while (i--) {
            if (listeners[i].listener === listener) {
                return i;
            }
        }

        return -1;
    }

    /**
     * Alias a method while keeping the context correct, to allow for overwriting of target method.
     *
     * @param {String} name The name of the target method.
     * @return {Function} The aliased method
     * @api private
     */
    function alias(name) {
        return function aliasClosure() {
            return this[name].apply(this, arguments);
        };
    }

    /**
     * Returns the listener array for the specified event.
     * Will initialise the event object and listener arrays if required.
     * Will return an object if you use a regex search. The object contains keys for each matched event. So /ba[rz]/ might return an object containing bar and baz. But only if you have either defined them with defineEvent or added some listeners to them.
     * Each property in the object response is an array of listener functions.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Function[]|Object} All listener functions for the event.
     */
    proto.getListeners = function getListeners(evt) {
        var events = this._getEvents();
        var response;
        var key;

        // Return a concatenated array of all matching events if
        // the selector is a regular expression.
        if (evt instanceof RegExp) {
            response = {};
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    response[key] = events[key];
                }
            }
        }
        else {
            response = events[evt] || (events[evt] = []);
        }

        return response;
    };

    /**
     * Takes a list of listener objects and flattens it into a list of listener functions.
     *
     * @param {Object[]} listeners Raw listener objects.
     * @return {Function[]} Just the listener functions.
     */
    proto.flattenListeners = function flattenListeners(listeners) {
        var flatListeners = [];
        var i;

        for (i = 0; i < listeners.length; i += 1) {
            flatListeners.push(listeners[i].listener);
        }

        return flatListeners;
    };

    /**
     * Fetches the requested listeners via getListeners but will always return the results inside an object. This is mainly for internal use but others may find it useful.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Object} All listener functions for an event in an object.
     */
    proto.getListenersAsObject = function getListenersAsObject(evt) {
        var listeners = this.getListeners(evt);
        var response;

        if (listeners instanceof Array) {
            response = {};
            response[evt] = listeners;
        }

        return response || listeners;
    };

    /**
     * Adds a listener function to the specified event.
     * The listener will not be added if it is a duplicate.
     * If the listener returns true then it will be removed after it is called.
     * If you pass a regular expression as the event name then the listener will be added to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListener = function addListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt);
        var listenerIsWrapped = typeof listener === 'object';
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key) && indexOfListener(listeners[key], listener) === -1) {
                listeners[key].push(listenerIsWrapped ? listener : {
                    listener: listener,
                    once: false
                });
            }
        }

        return this;
    };

    /**
     * Alias of addListener
     */
    proto.on = alias('addListener');

    /**
     * Semi-alias of addListener. It will add a listener that will be
     * automatically removed after its first execution.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addOnceListener = function addOnceListener(evt, listener) {
        return this.addListener(evt, {
            listener: listener,
            once: true
        });
    };

    /**
     * Alias of addOnceListener.
     */
    proto.once = alias('addOnceListener');

    /**
     * Defines an event name. This is required if you want to use a regex to add a listener to multiple events at once. If you don't do this then how do you expect it to know what event to add to? Should it just add to every possible match for a regex? No. That is scary and bad.
     * You need to tell it what event names should be matched by a regex.
     *
     * @param {String} evt Name of the event to create.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvent = function defineEvent(evt) {
        this.getListeners(evt);
        return this;
    };

    /**
     * Uses defineEvent to define multiple events.
     *
     * @param {String[]} evts An array of event names to define.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvents = function defineEvents(evts) {
        for (var i = 0; i < evts.length; i += 1) {
            this.defineEvent(evts[i]);
        }
        return this;
    };

    /**
     * Removes a listener function from the specified event.
     * When passed a regular expression as the event name, it will remove the listener from all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to remove the listener from.
     * @param {Function} listener Method to remove from the event.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListener = function removeListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt);
        var index;
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key)) {
                index = indexOfListener(listeners[key], listener);

                if (index !== -1) {
                    listeners[key].splice(index, 1);
                }
            }
        }

        return this;
    };

    /**
     * Alias of removeListener
     */
    proto.off = alias('removeListener');

    /**
     * Adds listeners in bulk using the manipulateListeners method.
     * If you pass an object as the second argument you can add to multiple events at once. The object should contain key value pairs of events and listeners or listener arrays. You can also pass it an event name and an array of listeners to be added.
     * You can also pass it a regular expression to add the array of listeners to all events that match it.
     * Yeah, this function does quite a bit. That's probably a bad thing.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add to multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListeners = function addListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(false, evt, listeners);
    };

    /**
     * Removes listeners in bulk using the manipulateListeners method.
     * If you pass an object as the second argument you can remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be removed.
     * You can also pass it a regular expression to remove the listeners from all events that match it.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListeners = function removeListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(true, evt, listeners);
    };

    /**
     * Edits listeners in bulk. The addListeners and removeListeners methods both use this to do their job. You should really use those instead, this is a little lower level.
     * The first argument will determine if the listeners are removed (true) or added (false).
     * If you pass an object as the second argument you can add/remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be added/removed.
     * You can also pass it a regular expression to manipulate the listeners of all events that match it.
     *
     * @param {Boolean} remove True if you want to remove listeners, false if you want to add.
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add/remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add/remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.manipulateListeners = function manipulateListeners(remove, evt, listeners) {
        var i;
        var value;
        var single = remove ? this.removeListener : this.addListener;
        var multiple = remove ? this.removeListeners : this.addListeners;

        // If evt is an object then pass each of its properties to this method
        if (typeof evt === 'object' && !(evt instanceof RegExp)) {
            for (i in evt) {
                if (evt.hasOwnProperty(i) && (value = evt[i])) {
                    // Pass the single listener straight through to the singular method
                    if (typeof value === 'function') {
                        single.call(this, i, value);
                    }
                    else {
                        // Otherwise pass back to the multiple function
                        multiple.call(this, i, value);
                    }
                }
            }
        }
        else {
            // So evt must be a string
            // And listeners must be an array of listeners
            // Loop over it and pass each one to the multiple method
            i = listeners.length;
            while (i--) {
                single.call(this, evt, listeners[i]);
            }
        }

        return this;
    };

    /**
     * Removes all listeners from a specified event.
     * If you do not specify an event then all listeners will be removed.
     * That means every event will be emptied.
     * You can also pass a regex to remove all events that match it.
     *
     * @param {String|RegExp} [evt] Optional name of the event to remove all listeners for. Will remove from every event if not passed.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeEvent = function removeEvent(evt) {
        var type = typeof evt;
        var events = this._getEvents();
        var key;

        // Remove different things depending on the state of evt
        if (type === 'string') {
            // Remove all listeners for the specified event
            delete events[evt];
        }
        else if (evt instanceof RegExp) {
            // Remove all events matching the regex.
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    delete events[key];
                }
            }
        }
        else {
            // Remove all listeners in all events
            delete this._events;
        }

        return this;
    };

    /**
     * Alias of removeEvent.
     *
     * Added to mirror the node API.
     */
    proto.removeAllListeners = alias('removeEvent');

    /**
     * Emits an event of your choice.
     * When emitted, every listener attached to that event will be executed.
     * If you pass the optional argument array then those arguments will be passed to every listener upon execution.
     * Because it uses `apply`, your array of arguments will be passed as if you wrote them out separately.
     * So they will not arrive within the array on the other side, they will be separate.
     * You can also pass a regular expression to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {Array} [args] Optional array of arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emitEvent = function emitEvent(evt, args) {
        var listenersMap = this.getListenersAsObject(evt);
        var listeners;
        var listener;
        var i;
        var key;
        var response;

        for (key in listenersMap) {
            if (listenersMap.hasOwnProperty(key)) {
                listeners = listenersMap[key].slice(0);
                i = listeners.length;

                while (i--) {
                    // If the listener returns true then it shall be removed from the event
                    // The function is executed either with a basic call or an apply if there is an args array
                    listener = listeners[i];

                    if (listener.once === true) {
                        this.removeListener(evt, listener.listener);
                    }

                    response = listener.listener.apply(this, args || []);

                    if (response === this._getOnceReturnValue()) {
                        this.removeListener(evt, listener.listener);
                    }
                }
            }
        }

        return this;
    };

    /**
     * Alias of emitEvent
     */
    proto.trigger = alias('emitEvent');

    /**
     * Subtly different from emitEvent in that it will pass its arguments on to the listeners, as opposed to taking a single array of arguments to pass on.
     * As with emitEvent, you can pass a regex in place of the event name to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {...*} Optional additional arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emit = function emit(evt) {
        var args = Array.prototype.slice.call(arguments, 1);
        return this.emitEvent(evt, args);
    };

    /**
     * Sets the current value to check against when executing listeners. If a
     * listeners return value matches the one set here then it will be removed
     * after execution. This value defaults to true.
     *
     * @param {*} value The new value to check for when executing listeners.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.setOnceReturnValue = function setOnceReturnValue(value) {
        this._onceReturnValue = value;
        return this;
    };

    /**
     * Fetches the current value to check against when executing listeners. If
     * the listeners return value matches this one then it should be removed
     * automatically. It will return true by default.
     *
     * @return {*|Boolean} The current value to check for or the default, true.
     * @api private
     */
    proto._getOnceReturnValue = function _getOnceReturnValue() {
        if (this.hasOwnProperty('_onceReturnValue')) {
            return this._onceReturnValue;
        }
        else {
            return true;
        }
    };

    /**
     * Fetches the events object and creates one if required.
     *
     * @return {Object} The events storage object.
     * @api private
     */
    proto._getEvents = function _getEvents() {
        return this._events || (this._events = {});
    };

    /**
     * Reverts the global {@link EventEmitter} to its previous value and returns a reference to this version.
     *
     * @return {Function} Non conflicting EventEmitter class.
     */
    EventEmitter.noConflict = function noConflict() {
        exports.EventEmitter = originalGlobalValue;
        return EventEmitter;
    };

    // Expose the class either via AMD, CommonJS or the global object
    if (typeof define === 'function' && define.amd) {
        define(function () {
            return EventEmitter;
        });
    }
    else if (typeof module === 'object' && module.exports){
        module.exports = EventEmitter;
    }
    else {
        exports.EventEmitter = EventEmitter;
    }
}.call(this));

var asserts = {};

function fail(field, name, obj) {
  throw new Error('[Front] expected ' + field + ' to be ' + name + ' (got ' + obj + ').');
}

['Arguments', 'Function', 'String', 'Number', 'Array', 'Date', 'RegExp', 'Boolean'].forEach(function (name) {
  function test(obj) {
    return Object.prototype.toString.call(obj) === '[object ' + name + ']';
  }

  asserts['opt' + name] = function (obj) {
    return test(obj) ? obj : null;
  };

  asserts['is' + name] = function (obj, field) {
    if (!test(obj))
      fail(field, name, obj);
  };

  asserts['test' + name] = function (obj) {
    return test(obj);
  };
});

asserts.isObject = function(obj, field) {
  var type = typeof obj;

  if (type !== 'function' && (type !== 'object' || !obj))
    fail(field, 'Object', obj);
};

function noop() {}

function Front() {
  this.started = false;
  this.seq = 0;
  this.pendingCb = {};
  this.customTargetWindow = null;
  this.qs = parseQuery();
  this.domain = this.qs.front_domain || 'https://app.frontapp.com';
  this.visible = false;
  this.debug = global.enableFrontDebugMode;
  this.background = global.enableFrontBackgroundMode;
  this.endpoint = location.href.replace(/[?&]auth_secret=.*$/, '');
}

this.heir.inherit(Front, this.EventEmitter);

Front.prototype.init = function (selector) {
  if (!selector)
    return;

  this.customTargetWindow = document.querySelector(selector).contentWindow;
};

Front.prototype._validateDomain = function () {
  // allow https://*.frontapp.com by default
  return global.allowAnyFrontDomain || /^https:\/\/[\w\-]+\.frontapp.com$/.test(this.domain);
};

Front.prototype._connected = function () {
  this.emit(this.started ? 'reconnect' : 'ready');
  this.started = true;
};

Front.prototype._dispatch = function (data) {
  var cb = this.pendingCb[data.seq];
  delete this.pendingCb[data.seq];

  if (cb && typeof(cb) === 'function') {
    cb(data.val);
  }
};

Front.prototype._postCb = function (data, cb) {
  asserts.isFunction(cb, 'cb');

  var seq = ++this.seq;
  data.seq = seq;

  this.pendingCb[seq] = cb;
  this.post(data);
};

Front.prototype.post = function (data) {
  var targetWindow = this.customTargetWindow || global.parent;
  data.endpoint = global.Front.endpoint;
  targetWindow.postMessage(data, this.domain);
};

Front.prototype.dialog = function (type, options, cb) {
  asserts.isObject(options, 'options');
  asserts.isString(options.title, 'options.title');
  asserts.isString(options.message, 'options.message');

  options.type = type;
  options.okTitle = asserts.optString(options.okTitle);
  options.cancelTitle = asserts.optString(options.cancelTitle);
  options.val = asserts.optString(options.val);

  this._postCb(options, cb);
};

['alert', 'confirm', 'prompt', 'report'].forEach(function (type) {
  Front.prototype[type] = function (options, cb) {
    this.dialog(type, options, cb);
  };
});

Front.prototype.promptDate = function (options, cb) {
  asserts.isObject(options, 'options');
  asserts.isObject(options.position, 'options.position');
  asserts.isNumber(options.position.left, 'options.position.left');
  asserts.isNumber(options.position.top, 'options.position.top');

  options.type = 'prompt_date';

  ['val', 'before', 'after'].forEach(function (field) {
    if (options[field]) {
      asserts.isDate(options[field], 'options.' + field);
      options[field] = options[field].getTime();
    }
  });

  this._postCb(options, function (ts) {
    cb(ts && new Date(ts));
  });
};

Front.prototype.fuzzylist = function (options, cb) {
  asserts.isObject(options, 'options');
  asserts.isArray(options.items, 'options.items');

  options.items.forEach(function (item) {
    asserts.isString(item.title);
    asserts.optString(item.completion);
  });

  options.type = 'fuzzylist';

  this._postCb(options, cb);
};

Front.prototype.copyToClipboard = function (payload) {
  this.post({type: 'copy_clipboard', payload: payload});
};

Front.prototype.openUrl = function (url) {
  this.post({type: 'open_url', url: url});
};

Front.prototype.openPopupUrl = function (url, title) {
  this.post({type: 'open_popup_url', url: url, title: title});
};

Front.prototype.openPopup = function (url, title) {
  var self = this;

  this._postCb({type: 'will_open_popup'}, function () {
    self._lastPopup = global.open(url, title, 'menubar=no,title,resize,location=no,width=650,height=530');
  });
};

Front.prototype.closePopup = function () {
  if (this._lastPopup) {
    this._lastPopup.close();
    this._lastPopup = null;
  }
};

Front.prototype.search = function (query) {
  this.post({type: 'search', query: query});
};

global.Front = new Front();

if (!global.Front._validateDomain()) {
  global.Front.log('error', '[Front] could not validate host domain ' + global.Front.domain);
  global.Front = null;
}

function parseQuery() {
  var query = window.location.search.substring(1),
      vars = query.split('&'),
      qs = {};

  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');

    if (pair.length === 2)
      qs[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }

  return qs;
}

var eventsToLog = ['conversation', 'no_conversation', 'panel_visible'];
global.addEventListener('message', function (event) {
  if (event.origin !== global.Front.domain) {
    global.Front.log('error', 'Received event from unexpected origin ' + event.origin);
    return;
  }

  var eventData = event.data;
  var eventType = eventData.type;

  if (eventsToLog.indexOf(eventType) >= 0)
    global.Front.log('info', 'Received ' + eventType + ' event.');

  switch(eventType) {
    case 'sync':
      global.Front._connected();
      break;

    case 'user':
      global.Front.user = eventData.user;
      break;

    case 'conversation':
      global.Front.emit('conversation', eventData);
      break;

    case 'no_conversation':
      global.Front.emit('no_conversation');
      break;

    case 'panel_visible':
      global.Front.visible = eventData.visible;
      global.Front.emit('panel_visible', eventData.visible);
      break;

    case 'done':
      global.Front._dispatch(eventData);
      break;
  }
});

global.addEventListener('click', function (event) {
  // nice try, Firefox…
  if (event.button !== 0 || global.parent === global)
    return;

  // If we have something like: <a href="xxx"> <strong>Label</strong> </a>, the <strong> might
  // catch the click event and we need to crawl the DOM to find the <a>.
  function findHref(element, depth) {
    if (!element || depth === 20)
      return null;

    if (element.tagName !== 'A' || !element.href)
      return findHref(element.parentElement, depth + 1);

    return element;
  }

  var link = findHref(event.target, 0);

  if (link) {
    // _blank opens in external window
    if (link.target !== '_blank')
      return;

    event.preventDefault();
    event.stopPropagation();

    global.Front.openUrl(link.href);
  }
});

// Tell the app that the library is ready to receive message
function init() {
  if (!global.Front)
    return;

  global.Front.post({type: 'plugin_connected', debug: global.Front.debug, background: global.Front.background});
  global.Front.log('info', 'Connecting...');
}

if (document.readyState !== 'loading')
  setTimeout(init, 0);
else
  window.addEventListener('DOMContentLoaded', init);

// * GETTERS

Front.prototype.fetchConversation = function (callback) {
  this._postCb({type: 'fetch_conversation'}, callback);
};

Front.prototype.fetchTeam = function (callback) {
  this._postCb({type: 'fetch_team'}, callback);
};

Front.prototype.fetchAllowedTeammates = function (callback) {
  this._postCb({type: 'fetch_allowed_teammates'}, callback);
};

Front.prototype.fetchInboxes = function (callback) {
  this._postCb({type: 'fetch_inboxes'}, callback);
};

Front.prototype.fetchChannels = function (callback) {
  this._postCb({type: 'fetch_channels'}, callback);
};

Front.prototype.fetchAllowedTags = function (callback) {
  this._postCb({type: 'fetch_tags'}, callback);
};

Front.prototype.fetchNotes = function (callback) {
  this._postCb({type: 'fetch_notes'}, callback);
};

Front.prototype.fetchDraft = function (callback) {
  this._postCb({type: 'fetch_draft'}, callback);
};

// Non-documented method to fetch the PATH of the parent window.
Front.prototype.fetchAppPath = function (callback) {
  this._postCb({type: 'fetch_app_path'}, callback);
}

// * HELPERS
// *
// * conversation is not used yet, but will be soon

Front.prototype.unassign = function (conversation) {
  this.post({
    type: 'unassign',
    conversation_id: conversation ? conversation.id : null
  });
};

Front.prototype.assign = function (assignee, conversation) {
  var assigneeAlias = toAlias(assignee);

  this.post({
    type: 'assign',
    assignee: assigneeAlias,
    conversation_id: conversation ? conversation.id : null
  });
};

Front.prototype.attachTag = function (tag, conversation) {
  var tagAlias = toAlias(tag);

  this.post({
    type: 'tag',
    tag: tagAlias,
    conversation_id: conversation ? conversation.id : null
  });
};

Front.prototype.detachTag = function (tag, conversation) {
  var tagAlias = toAlias(tag);

  this.post({
    type: 'untag',
    tag: tagAlias,
    conversation_id: conversation ? conversation.id : null
  });
};

Front.prototype.toggleTag = function (tag, conversation) {
  var tagAlias = toAlias(tag);

  this.post({
    type: 'toggle_tag',
    tag: tagAlias,
    conversation_id: conversation ? conversation.id : null
  });
};

Front.prototype.toggleArchive = function (conversation) {
  this.post({
    type: 'toggle_archived',
    conversation_id: conversation ? conversation.id : null
  });
};

Front.prototype.toggleTrashed = function (conversation) {
  this.post({
    type: 'toggle_trashed',
    conversation_id: conversation ? conversation.id : null
  });
};

Front.prototype.moveToInbox = function (inbox) {
  var inboxAlias = toAlias(inbox);

  this.post({
    type: 'move_to_inbox',
    inbox: inboxAlias,
    inbox_alias: inboxAlias
  });
};

Front.prototype.addTopic = function (topic, cb) {
  asserts.isObject(topic);
  asserts.optString(topic.type);
  asserts.optString(topic.name);
  asserts.isString(topic.ext_link);

  this._postCb({type: 'add_topic', topic: topic}, cb);
};

Front.prototype.reply = function (options, replyAll, conversation, callback) {
  options = options || {};

  // conversation is optionnal
  if (!callback && typeof conversation === 'function')
    callback = conversation;

  callback = callback || noop;

  asserts.isObject(options);
  asserts.optString(options.body);
  asserts.optString(options.html);
  asserts.optString(options.text);
  asserts.optString(options.subject);
  asserts.optBoolean(options.send_now);
  asserts.optBoolean(options.mark_archived);
  asserts.optArray(options.to);
  asserts.optArray(options.cc);
  asserts.optArray(options.bcc);
  asserts.optArray(options.attachment_uids);

  var tags = [];

  if (options.tags) {
    asserts.isArray(options.tags);

    options.tags.forEach(function (tag) {
      tags.push(toAlias(tag));
    });
  }

  this._postCb({
    type: replyAll ? 'reply_all' : 'reply',
    tags: tags,
    body: makeBody(options),
    subject: options.subject || null,
    send_now: options.send_now || false,
    mark_archived: options.mark_archived || null,
    to: options.to || null,
    cc: options.cc || null,
    bcc: options.bcc || null,
    conversation_id: conversation ? conversation.id : null,
    attachment_uids: options.attachment_uids || null
  }, callback);
};

// Deprecated
Front.prototype.forwardTo = function (handle, options) {
  options = options || {};

  asserts.optString(handle);
  asserts.optString(options.body);
  asserts.optString(options.subject);

  this.post({
    type: 'forward',
    body: makeBody(options),
    subject: options.subject || null,
    send_now: options.send_now || false,
    mark_archived: options.mark_archived || null,
    to: handle
  });
};

Front.prototype.forward = function (options, callback) {
  options = options || {};
  callback = callback || noop;

  asserts.optArray(options.to);
  asserts.optArray(options.cc);
  asserts.optArray(options.bcc);
  asserts.optString(options.body);
  asserts.optString(options.subject);
  asserts.optArray(options.attachment_uids);

  this._postCb({
    type: 'forward',
    body: makeBody(options),
    subject: options.subject || null,
    send_now: options.send_now || false,
    mark_archived: options.mark_archived || null,
    to: options.to || null,
    cc: options.cc || null,
    bcc: options.bcc || null,
    attachment_uids: options.attachment_uids || null
  }, callback);
}

Front.prototype.compose = function (options, callback) {
  options = options || {};
  callback = callback || noop;

  asserts.isObject(options);
  asserts.optArray(options.to);
  asserts.optArray(options.cc);
  asserts.optArray(options.bcc);
  asserts.optString(options.from);
  asserts.optString(options.subject);
  asserts.optString(options.body);
  asserts.optBoolean(options.send_now);
  asserts.optBoolean(options.hide_composer);
  asserts.optBoolean(options.mark_archived);
  asserts.optArray(options.attachment_uids);

  var inboxAlias = toOptAlias(options.inbox),
      tags = [];

  if (options.tags) {
    asserts.isArray(options.tags);

    options.tags.forEach(function (tag) {
      tags.push(toAlias(tag));
    });
  }

  this._postCb({
    type: 'compose',
    from: options.from || null,
    to: options.to || null,
    cc: options.cc || null,
    bcc: options.bcc || null,
    body: makeBody(options),
    subject: options.subject || null,
    send_now: options.send_now || false,
    hide_composer: options.hide_composer,
    mark_archived: options.mark_archived || null,
    specifiedInboxAlias: inboxAlias,
    tags: tags,
    attachment_uids: options.attachment_uids || null
  }, callback);
};

Front.prototype.insertHTML = function (html) {
  asserts.isString(html);
  this.post({type: 'insert_html', html: html});
};

Front.prototype.updateDraft = function (draftId, options, callback) {
  options = options || {};
  callback = callback || noop;

  asserts.isString(draftId);
  asserts.isObject(options);
  if (options.recipients) {
    asserts.optArray(options.recipients.to);
    asserts.optArray(options.recipients.cc);
    asserts.optArray(options.recipients.bcc);
  }
  asserts.optArray(options.attachment_uids);

  this._postCb({
    type: 'update_draft',
    draft_id: draftId,
    recipients: options.recipients || null,
    attachment_uids: options.attachment_uids || null
  }, callback);
};

Front.prototype.setPanelWidth = function (width) {
  asserts.isNumber(width);
  this.post({type: 'set_width', width: width});
};

var availableLogLevel = ['log', 'info', 'error', 'warn'];
Front.prototype.log = function (level, message) {
  if (!this.debug || availableLogLevel.indexOf(level) < 0 || !global.console)
    return;

  global.console[level]('[Front] Plugin (' + this.endpoint + '): ', message);
};

function toOptAlias(obj) {
  return obj ? toAlias(obj) : null;
}

function toAlias(obj) {
  if (asserts.testString(obj))
    return obj;

  asserts.isObject(obj);
  asserts.isString(obj.alias);

  return obj.alias;
}

function makeBody(options) {
  if (options.html) {
    return options.html;
  } else if (options.body) {
    return options.body;
  } else if (options.text) {
    var div = document.createElement('div');
    div.innerText = options.text;

    return div.innerHTML;
  } else {
    return '';
  }
}

}).call({}, window);